"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleFacilityWithResourcesDto = exports.UpdateResourceDto = exports.ResourceScheduleDto = exports.ByResourceTypeDto = exports.UpdateResourceDetailsDto = exports.ByOrganizationIdAndResourceId = exports.ByOrganizationIdAndResourceTypeAndIdDto = exports.ByOrganizationFacilityIdDto = exports.ByOrganizationIdAndResourceTypeDto = exports.GetResourceByIdOptionsDto = exports.GetResourcesOfFacilityByTypeDto = exports.ResourceDependenciesDto = exports.BaseResourceDto = exports.CalendarResourceDto = exports.ChildCalendarResourceDto = exports.InvalidResourceDto = exports.ResourceDto = void 0;
const facilities_dto_1 = require("../../dto/facilities.dto");
const general_dto_1 = require("../../dto/general.dto");
const organization_dto_1 = require("../../organization/dto/organization.dto");
class ResourceDto {
}
exports.ResourceDto = ResourceDto;
class InvalidResourceDto extends ResourceDto {
}
exports.InvalidResourceDto = InvalidResourceDto;
class ChildCalendarResourceDto extends general_dto_1.IdAndNameDto {
}
exports.ChildCalendarResourceDto = ChildCalendarResourceDto;
class CalendarResourceDto extends ChildCalendarResourceDto {
}
exports.CalendarResourceDto = CalendarResourceDto;
class BaseResourceDto extends general_dto_1.IdDto {
}
exports.BaseResourceDto = BaseResourceDto;
class ResourceDependenciesDto {
}
exports.ResourceDependenciesDto = ResourceDependenciesDto;
class GetResourcesOfFacilityByTypeDto {
}
exports.GetResourcesOfFacilityByTypeDto = GetResourcesOfFacilityByTypeDto;
class GetResourceByIdOptionsDto extends general_dto_1.IncludeAdditionalDataDto {
}
exports.GetResourceByIdOptionsDto = GetResourceByIdOptionsDto;
class ByOrganizationIdAndResourceTypeDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByOrganizationIdAndResourceTypeDto = ByOrganizationIdAndResourceTypeDto;
class ByOrganizationFacilityIdDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByOrganizationFacilityIdDto = ByOrganizationFacilityIdDto;
class ByOrganizationIdAndResourceTypeAndIdDto extends ByOrganizationIdAndResourceTypeDto {
}
exports.ByOrganizationIdAndResourceTypeAndIdDto = ByOrganizationIdAndResourceTypeAndIdDto;
class ByOrganizationIdAndResourceId extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByOrganizationIdAndResourceId = ByOrganizationIdAndResourceId;
class UpdateResourceDetailsDto {
}
exports.UpdateResourceDetailsDto = UpdateResourceDetailsDto;
class ByResourceTypeDto {
}
exports.ByResourceTypeDto = ByResourceTypeDto;
class ResourceScheduleDto {
}
exports.ResourceScheduleDto = ResourceScheduleDto;
class UpdateResourceDto {
}
exports.UpdateResourceDto = UpdateResourceDto;
class SimpleFacilityWithResourcesDto extends facilities_dto_1.SimpleFacilityDto {
}
exports.SimpleFacilityWithResourcesDto = SimpleFacilityWithResourcesDto;
//# sourceMappingURL=resource.dto.js.map